import {Produktresponse} from "../js/databaseInterfaceClasses";
import {sendPostRequest} from "./axiosFormWrapper";
import {AuswahlProdukt} from "../js/product";
import globalsObject from "../js/globalsObject";
import {EventVerteiler} from "./eventVerteiler";
import {ProduktAuswahlProdukt} from "../../konfi_mobile/src/store/ProduktAuswahlStore";


type ProduktPHPParameters = {
    schnitt: string,
    sport: string,
    websport:string
    ordertype: string,
    webProduct: string,
    iso: string,
    produktAuwi: string
    showUnpublishedDesigns: boolean
    features: string
}

export function createProduktPHPParameters(product:AuswahlProdukt|ProduktAuswahlProdukt, selectedFeatures, websportNormalized, languageIso, directLogin):ProduktPHPParameters {
    return {
        schnitt: product.Schnitt,
        sport: product.Realsport,
        websport:websportNormalized,
        sportAnzeigeKategorie: product.Realsport,
        ordertype: product.Ordertype,
        webProduct: product.Produkt,
        iso: languageIso,
        produktAuwi: product.AuwiProdukt,
        showUnpublishedDesigns: directLogin,
        features: JSON.stringify(selectedFeatures)
    } as ProduktPHPParameters;
}

export function loadproduktPhpAndRegisterResource(params:ProduktPHPParameters, resourceNameSuffix=""):Promise<Produktresponse> {
    EventVerteiler.resourceManager.deleteResourceByName("produkt.php"+resourceNameSuffix)
    return new Promise<Produktresponse>((resolve, reject)=>{
        sendPostRequest("/konfigurator_php/auswahlmodul/produkt.php", params).then(response=>{
            globalsObject.resourceManager.registerProduktPHPResource(response.data, resourceNameSuffix);
            resolve(response.data)
        }).catch(()=>{
            reject()
        })
    })
}
